'use client';

import * as React from 'react';
import { motion, useAnimation } from 'framer-motion';

interface IconProps {
	isHovered: boolean;
}

export function CircleChevronDownIcon({ isHovered }: IconProps) {
	const controls = useAnimation();

	React.useEffect(() => {
		void controls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, controls]);

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='28'
				height='28'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<circle cx='12' cy='12' r='10' />
				<motion.path
					variants={{
						normal: { y: 0 },
						animate: {
							y: [0, 2, 0],
						},
					}}
					transition={{
						times: [0, 0.4, 1],
						duration: 0.5,
					}}
					animate={controls}
					d='m16 10-4 4-4-4'
				/>
			</svg>
		</div>
	);
}
